import {
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useState } from 'react';
import { useAuth, ACTIONS } from '@/contexts/auth';
import { useTranslation } from 'react-i18next';

export default function AvatarMenu() {
  const { user, dispatch } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch({ type: ACTIONS.LOGOUT });
    handleClose();
  };

  const getInitials = (name?: string) => {
    if (!name) return 'N/A';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ ml: 2 }}>
        <Avatar sx={{ bgcolor: 'secondary.main' }}>
          {getInitials(user?.name as string)}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          {t('Exit')}
        </MenuItem>
      </Menu>
    </>
  );
}
